import React, { useEffect, useState, useMemo } from "react";
import { Card, CardBody, Button } from "reactstrap";
import { AgGridReact } from "ag-grid-react";
import { useNavigate } from "react-router-dom";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import { CreateCustomerList } from "../../ApiEndPoint/ApiCalling";

export default function CustomerList() {
  const navigate = useNavigate();

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);

  // ✅ COLUMN DEFINITIONS
  const columnDefs = useMemo(() => [
    { headerName: "Company Name", field: "CompanyName", width: 200 },

    { headerName: "GST Number", field: "gstNumber", width: 160 },

    { headerName: "Party Type", field: "partyType", width: 140 },

    { headerName: "Registration Type", field: "registrationType", width: 160 },

    { headerName: "Lockin Time", field: "lockInTime", width: 120 },

    { headerName: "Limit", field: "limit", width: 100 },

    { headerName: "Payment Term", field: "paymentTerm", width: 150 },

    { headerName: "Company PAN", field: "comPanNo", width: 160 },

    { headerName: "Contact Number", field: "contactNumber", width: 150 },

    {
      headerName: "Sales Person",
      valueGetter: (params) => params.data?.created_by?.firstName || "",
      width: 160,
    },

    {
      headerName: "Sales Contact",
      valueGetter: (params) => params.data?.created_by?.mobileNumber || "",
      width: 180,
    },

    { headerName: "Owner Name", field: "ownerName", width: 180 },

    { headerName: "Mobile", field: "mobileNumber", width: 150 },

    { headerName: "Aadhar No", field: "aadharNo", width: 160 },

    { headerName: "State", field: "State", width: 140 },

    { headerName: "City", field: "City", width: 140 },

    {
      headerName: "Transporter",
      valueGetter: (params) =>
        params.data?.transporterDetail === 0 ? "Local" : "Other",
      width: 140,
    },

    { headerName: "Service Area", field: "serviceArea", width: 150 },

    { headerName: "Geo Tagging", field: "geotagging", width: 150 },

    {
      headerName: "Category",
      valueGetter: (params) => params.data?.category?.groupName || "",
      width: 160,
    },

    { headerName: "Email", field: "email", width: 220 },

    { headerName: "Deals In", field: "dealsInProducts", width: 140 },

    { headerName: "Annual Turnover", field: "annualTurnover", width: 180 },

    { headerName: "Pin Code", field: "pincode", width: 120 },

    {
      headerName: "Role ID",
      valueGetter: (params) => params.data?.rolename?.id || "",
      width: 140,
    },

    { headerName: "User ID", field: "id", width: 160 },

    { headerName: "Status", field: "status", width: 120 },
  ], []);

  // ✅ API CALL
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const userData = JSON.parse(localStorage.getItem("userData"));
        const res = await CreateCustomerList(
          userData?._id,
          userData?.database
        );

        const value = res?.Customer || [];

        const filtered = value.filter((ele) => {
          return (
            ele?.panNo ||
            ele?.aadharNo ||
            ele?.CompanyName?.toUpperCase() === "CASH"
          );
        });

        setRowData(filtered.reverse());
      } catch (err) {
        console.log(err);
      }

      setLoading(false);
    };

    fetchData();
  }, []);

  return (
    <Card>
      <CardBody>

        {/* 🔥 HEADER */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "10px",
          }}
        >
          <h4>Customer List</h4>

          <Button
            color="primary"
            onClick={() =>
              navigate("/users?view=CreateCustomer")
            }
          >
            + Create Customer
          </Button>
        </div>

        {/* 🔥 GRID */}
        <div
          className="ag-theme-alpine"
          style={{ width: "100%", height: "75vh" }}
        >
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            pagination={true}
            paginationPageSize={20}
            animateRows={true}
          />
        </div>

      </CardBody>
    </Card>
  );
}